import React, { useState } from 'react';
import css from './ListingPage.module.css';

/**
 * SectionFAQs Component
 *
 * Displays a list of frequently asked questions in accordion format.
 * Each FAQ can be expanded/collapsed individually.
 * Only renders if FAQs exist in publicData.
 *
 * @param {Array} faqs - Array of objects {question, answer} from publicData
 * @param {Object} intl - Internationalization object for translating labels
 */
const SectionFAQs = props => {
  const { faqs, intl } = props;

  // State: stores the index of the currently open FAQ (null = all closed)
  const [openIndex, setOpenIndex] = useState(0);

  /**
   * Toggles a specific FAQ open/closed
   * @param {number} index - Index of the clicked FAQ
   */
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Don't render if no FAQs exist
  if (!faqs || faqs.length === 0) return null;

  return (
    <div className={css.propsContainer}>
      <div className={css.listingProp}>
        {/* Section title - translated */}
        <div>{intl.formatMessage({ id: 'ListingPage.faqsLabel' })}</div>

        {/* FAQs container */}
        <div className={css.faqContainer}>
          {faqs.map((faq, index) => (
            <div key={index} className={css.faqItem}>
              {/* Question button - toggles accordion */}
              <button
                className={css.faqQuestion}
                onClick={() => toggleFAQ(index)}
                type="button"
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                {/* Arrow icon - rotates when open */}
                <span className={openIndex === index ? css.faqArrowOpen : css.faqArrowClosed}>
                  <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.7168 1L7.7168 7L13.7168 1" fill="none" stroke="#6E7191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </button>

              {/* Answer - only visible when open */}
              {openIndex === index && (
                <div className={css.faqAnswer}>
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionFAQs;
